import React from "react";
import { Card } from "./ui/card";
import { Button } from "./ui/button";
import { Phone, MessageCircle, Cog, Brain, Sparkles, Target, Users, ArrowRight, Trophy } from "lucide-react";

const Services = () => {
  const services = [
    {
      icon: <Phone className="h-8 w-8 text-purple-600" />,
      title: "Asistentes telefónicos inteligentes",
      description: "Sistemas de voz que gestionan llamadas, resuelven consultas y programan citas de forma autónoma, manteniendo la calidad humana en cada interacción.",
      subtitle: "Disponibles 24/7 con número local español."
    },
    {
      icon: <MessageCircle className="h-8 w-8 text-blue-600" />,
      title: "Conversaciones automatizadas",
      description: "Chatbots avanzados integrados en tus canales de comunicación preferidos, desde redes sociales hasta tu página web.",
      subtitle: "Interacciones naturales que generan confianza y conversiones."
    },
    {
      icon: <Cog className="h-8 w-8 text-green-600" />,
      title: "Flujos de trabajo inteligentes",
      description: "Automatización completa de procesos internos: gestión de leads, seguimiento de clientes y optimización de tu sistema CRM.",
      subtitle: "Eficiencia máxima sin perder el toque personal."
    },
    {
      icon: <Brain className="h-8 w-8 text-orange-600" />,
      title: "Estrategia de IA a medida",
      description: "Desarrollamos soluciones personalizadas que se adaptan a tu sector y objetivos específicos, desde análisis de datos hasta automatización compleja.",
      subtitle: "Innovación que impulsa tu ventaja competitiva."
    }
  ];

  return (
    <section id="servicios" className="py-20 lg:py-32 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-800 mb-4">
            Servicios de IA para tu empresa
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Soluciones inteligentes que transforman tu negocio y liberan tu tiempo para lo que realmente importa
          </p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <Card 
              key={index}
              className="p-8 bg-white hover:shadow-xl transition-all duration-300 border-0 shadow-lg hover:transform hover:scale-105 group"
            >
              {/* Decorative elements */}
              <div className="relative mb-6">
                <div className="absolute inset-0 bg-gradient-to-br from-purple-50 to-blue-50 rounded-2xl transform rotate-3 group-hover:rotate-6 transition-transform duration-300"></div>
                <div className="relative bg-white p-4 rounded-2xl shadow-sm">
                  {service.icon}
                  <div className="absolute top-2 right-2">
                    <Sparkles className="h-4 w-4 text-purple-300" />
                  </div>
                  <div className="absolute bottom-2 left-2">
                    <Target className="h-3 w-3 text-blue-300" />
                  </div>
                  <div className="absolute top-4 left-1/2 transform -translate-x-1/2">
                    <div className="w-1 h-1 bg-purple-300 rounded-full"></div>
                  </div>
                  <div className="absolute bottom-4 right-1/3">
                    <div className="w-1 h-1 bg-blue-300 rounded-full"></div>
                  </div>
                </div>
              </div>

              <h3 className="text-xl font-bold text-gray-800 mb-4 group-hover:text-purple-600 transition-colors">
                {service.title}
              </h3>
              
              <p className="text-gray-600 text-sm leading-relaxed mb-4">
                {service.description}
              </p>
              
              {service.subtitle && (
                <p className="text-gray-500 text-sm italic font-medium">
                  {service.subtitle}
                </p>
              )}
            </Card>
          ))}
        </div>

        {/* Success Cases CTA */}
        <div className="mt-16 text-center">
          <div className="bg-gradient-to-r from-purple-50 to-blue-50 rounded-2xl p-8 border border-purple-100">
            <div className="flex items-center justify-center mb-4">
              <Trophy className="h-6 w-6 text-purple-600 mr-2" />
              <span className="text-sm font-semibold text-purple-600 uppercase tracking-wide">
                Casos de Éxito
              </span>
            </div>
            <h3 className="text-2xl font-bold text-gray-800 mb-3">
              ¿Quieres ver resultados reales?
            </h3>
            <p className="text-gray-600 mb-6 max-w-2xl mx-auto">
              Descubre cómo hemos transformado empresas como la tuya con soluciones de IA personalizadas.
            </p>
            <Button 
              onClick={() => window.location.href = '/casos-exito'}
              className="bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-700 hover:to-blue-700 text-white px-6 py-3 font-semibold shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
            >
              Ver casos de éxito
              <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;